import Swiper, { EffectFade, Lazy, Thumbs, Autoplay, Navigation, Pagination, Zoom } from 'swiper';

// const thumbnailsSlider = new Swiper('.single-product-slider-thumbnails', {
//     modules: [Autoplay],
//     slidesPerView: 1,
//     direction: 'horizontal',
//     watchSlidesVisibility: true,
//     autoplay: {
//         delay: 5000,
//     },
// });

const singleProductSlider = new Swiper('.single-product-slider', {
    modules: [EffectFade, Lazy, Thumbs, Autoplay, Navigation, Pagination, Zoom],
    effect: 'slide',
    zoom: true,
    zoom: {
      maxRatio:2,
    },
    fadeEffect: {
        crossFade: true,
    },
    // thumbs: {
    //     swiper: thumbnailsSlider,
    // },
    // autoHeight: true,
    loop: true,
    preloadImages: true,
    watchSlidesVisibility: true,
    lazy: {
        preloaderClass: 'single-product-slider-preloader',
        loadPrevNext: true,
        loadPrevNextAmount: 2
    },
    //     autoplay: {
    //     delay: 5000,
    // },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
});

$(document).ready(function () {
    $(this)
        .find('.zoom-container')
        .on('mouseenter', function () {
            $('.zoomed-image').css('opacity', '1');
        });

    $('.zoom-container').on('mousemove', function (e) {
        var containerOffset = $(this).offset();
        var containerWidth = $(this).width();
        var containerHeight = $(this).height();
        var mouseX = e.pageX - containerOffset.left;
        var mouseY = e.pageY - containerOffset.top;
        var zoomedWidth = $('.zoomed-image').width();
        var zoomedHeight = $('.zoomed-image').height();
        var offsetX = (mouseX / containerWidth) * (zoomedWidth - containerWidth);
        var offsetY = (mouseY / containerHeight) * (zoomedHeight - containerHeight);

        // Ustawienie punktu transformacji na pozycji kursora myszy względem kontenera
        var transformOriginX = (mouseX / containerWidth) * 100 + '%';
        var transformOriginY = (mouseY / containerHeight) * 100 + '%';

        $(this)
            .find('.zoomed-image')
            .css({
                'transform-origin': transformOriginX + ' ' + transformOriginY,
                transform: 'scale(1.5)',
                opacity: '1',
            });
    });

    $('.zoom-container').on('mouseleave', function () {
        $(this).find('.zoomed-image').css({
            opacity: '0',
            'transform-origin': '50% 50%',
            transform: 'none',
        });
    });
});
